var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-collapse-transition',[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.path}):_vm._e()],1)],1),_c('el-collapse-transition',[(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.path}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }